const LOCAL_STORAGE_TYPES = {
    restart: 'restart',
    welcomeDialogSeen: 'welcomeDialogSeen',
    autoRefreshTimeout: 'autoRefreshTimeout',
}

export {
    LOCAL_STORAGE_TYPES,
}
